import { Row } from './types';
import { sumColumns } from '../common';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

export const columns: ControlledTableColumns<Row> = [
  {
    content: 'Agency',
    key: 'enterprise_slug',
    width: 80,
  },
  flexColumn({
    content: 'Type',
    key: 'type',
    required: true,
    sortable: true,
  }),
  ...sumColumns,
];
